import Breadcrumb from "../Component/Breadcrumb"
import Footer from "../Component/Footer"
import Header from "../Component/Header"

const Chairman = () => {
    return (
        <>
            <Header />
            <Breadcrumb title="Chairman’s Message" midBreadcrumb="Message" mainBreadcrumb="Chairman’s Message" ></Breadcrumb>
            <div className='inner-page message'>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="clearfix">
                                <h2 className="mainhead">Chairman’s Message</h2>
                                <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/Chairman.jpg" className="col-md-5 float-md-end rit-img" alt="Mata Mariam Jan Seva Vidyalay" />
                                <p>It gives me joy to offer my felicitations on the occasion
                                    of the Silver Jubilee of Mata Mariam Jan Seva Vidyalaya, Narnaul. The twenty five years indeed were
                                    glorious as we can see the changes that this school have brought out in the lives of thousands of students
                                    and community in a backward village. The school has proved to be a gift of the Catholic Church to Nation
                                    Building as it has formed and motivated countless youngsters who are now serving the nation and people at
                                    various levels.</p>
                                <p>The track record of the school in academics, value-based
                                    education, sports and cultural development is really remarkable and the school has become a model of
                                    excellence in a region where people are still fighting educational and social backwardness. I am sure that
                                    the school will continue to be a beacon of hope for the coming generations in that region and the state.
                                </p>
                                <p>I would like to take a moment to render my grateful  tributes to all the Managers, Principals, Teachers, non-teaching staff and the students who were part of
                                    this great institution in the past 25 years and contributed to its growth to glory. My best wishes for the
                                    Souvenir themed as “Magnificat” which will certainly depict the magnificent moments of accomplishments in
                                    the saga of 25 years of splendid service.</p>

                                <p>May God lavish His abundant blessings upon Mata Mariam Jan
                                    Seva Vidyalaya and its all stakeholders on the occasion of its Silver Jubilee.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default Chairman